import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { ongoingProjectsService } from '../../../services/OngoingProjectsService';
import ReactPaginate from 'react-paginate';

class AdminOngoingProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      disabledPicture: false,
      newOngoingProject: {
        title: '',
        description: '',
        value: '',
        start_date: '',
        end_date: '',
        finished: false,
        picture: '',
        document: ''
      },
      existingProjects: [],
      deleteProject: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    ongoingProjectsService
      .getAll()
      .then(jsonResponse => {
        this.setOngoingProjectsState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    ongoingProjectsService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setOngoingProjectsState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setOngoingProjectsState = response => {
    let existingProjects = { ...this.state.existingProjects };
    let pagination = { ...this.state.pagination };
    existingProjects = response.ongoing_projects;
    pagination = response.pagination;

    this.setState({ existingProjects });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newOngoingProject = this.state.newOngoingProject;
    newOngoingProject[field] = event.target.value;

    this.setState({
      newOngoingProject
    });
  };

  onDropPicture = documents => {
    let newOngoingProject = { ...this.state.newOngoingProject };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newOngoingProject.picture = documents[0];

      self.setState({ newOngoingProject });
      self.setState({ disabledPicture: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removePicture = () => {
    let newOngoingProject = { ...this.state.newOngoingProject };
    newOngoingProject.picture = null;

    this.setState({ newOngoingProject });
    this.setState({ disabledPicture: false });
  };

  onDropDocument = documents => {
    let newOngoingProject = { ...this.state.newOngoingProject };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newOngoingProject.document = documents[0];

      self.setState({ newOngoingProject });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newOngoingProject = { ...this.state.newOngoingProject };
    newOngoingProject.document = null;

    this.setState({ newOngoingProject });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newOngoingProject = { ...this.state.newOngoingProject };
    newOngoingProject = {
      title: '',
      description: '',
      value: '',
      start_date: '',
      end_date: '',
      finished: false,
      document: ''
    };

    this.setState({ newOngoingProject });
    this.setState({ disabledDocuments: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newOngoingProject.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/ongoing_projects/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/ongoing_projects/${this.state.newOngoingProject.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingProjects = this.state.existingProjects.slice();

        let index = existingProjects.findIndex(
          existingProject => existingProject.id === jsonResponse.id
        );

        if (index !== -1) {
          existingProjects[index] = jsonResponse;
        } else {
          existingProjects.push(jsonResponse);
        }

        this.setState({ existingProjects });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Proiectul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Proiectul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'ongoing_project[title]',
      this.state.newOngoingProject.title
    );
    formData.append(
      'ongoing_project[description]',
      this.state.newOngoingProject.description
    );
    formData.append(
      'ongoing_project[value]',
      this.state.newOngoingProject.value
    );
    formData.append(
      'ongoing_project[start_date]',
      this.state.newOngoingProject.start_date
    );
    formData.append(
      'ongoing_project[finished]',
      this.state.newOngoingProject.finished
    );
    formData.append(
      'ongoing_project[end_date]',
      this.state.newOngoingProject.end_date
    );

    if (this.state.newOngoingProject.picture) {
      let picture = this.state.newOngoingProject.picture;
      appendAttachment(formData, `ongoing_project[picture]`, picture);
    }

    if (this.state.newOngoingProject.document) {
      let document = this.state.newOngoingProject.document;
      appendAttachment(formData, `ongoing_project[document]`, document);
    }

    return formData;
  }

  setCertificateForEdit = newProject => {
    let newOngoingProject = { ...this.state.newOngoingProject };
    newOngoingProject = Object.assign({}, newProject);
    this.setState({ newOngoingProject });

    if (newProject.document.url) {
      this.setState({ disabledDocument: true });
    }

    if (newProject.picture.url) {
      this.setState({ disabledPicture: true });
    }
  };

  openDeleteDialog = id => {
    let deleteProject = { ...this.state.deleteProject };
    deleteProject = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteProject });
  };

  closeDeleteDialog = () => {
    let deleteProject = { ...this.state.deleteProject };
    deleteProject = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteProject });
  };

  handleDelete = () => {
    ongoingProjectsService
      .deleteOngoingProject(this.state.deleteProject.deleteId)
      .then(() => {
        let existingProjects = this.state.existingProjects.slice();
        existingProjects = existingProjects.filter(
          project => project.id !== this.state.deleteProject.deleteId
        );
        this.setState({ existingProjects });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Proiectul a fost stears cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  toggleCkeck = () => {
    var newOngoingProject = { ...this.state.newOngoingProject };
    newOngoingProject.finished = !newOngoingProject.finished;
    this.setState({ newOngoingProject });
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title">
            Proiecte in desfasurare
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga un proiect nou</h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu proiect*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newOngoingProject.title}
                  />

                  <h4 className="label-title label-title-provisions">
                    Descriere proiect*
                  </h4>
                  <textarea
                    required
                    rows="5"
                    className="general-field title-field"
                    type="text"
                    name="description"
                    onChange={this.updateField}
                    value={this.state.newOngoingProject.description}
                  />

                  <h4 className="label-title label-title-provisions">
                    Valoare proiect (valoarea este reprezentata in RON)*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="number"
                    name="value"
                    onChange={this.updateField}
                    value={this.state.newOngoingProject.value}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată inceput*
                  </h4>
                  <input
                    required
                    className="general-field date-field"
                    type="date"
                    name="start_date"
                    onChange={this.updateField}
                    value={this.state.newOngoingProject.start_date}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată finalizare*
                  </h4>
                  <input
                    required
                    className="general-field date-field"
                    type="date"
                    name="end_date"
                    onChange={this.updateField}
                    value={this.state.newOngoingProject.end_date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Imagine reprezentativa:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropPicture}
                    removeDocument={this.removePicture}
                    disabledDocuments={this.state.disabledPicture}
                    document={this.state.newOngoingProject.picture}
                    documentFilename={
                      this.state.newOngoingProject.picture_filename
                    }
                    type="image/*"
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document proiect:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newOngoingProject.document}
                    documentFilename={
                      this.state.newOngoingProject.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="admin-form__checkbox">
                  <h4 className="label-title label-title-provisions">
                    Marcheaza Proiect Finalizat:
                  </h4>
                  <input
                    type="checkbox"
                    className="checkbox-input"
                    name="important"
                    onChange={this.toggleCkeck}
                    checked={this.state.newOngoingProject.finished}
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newOngoingProject.id
                        ? 'Editează Proiect'
                        : 'Adaugă Proiect'}
                    </button>
                  </div>
                  {Object.values(this.state.newOngoingProject) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingProjects.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Proiecte in desfasurare existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingProjects.map(project => (
                      <div
                        className="existing-items__content-card"
                        key={project.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {project.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() => this.setCertificateForEdit(project)}
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() => this.openDeleteDialog(project.id)}
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteProject.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest proiect?"
                    aditionalText="Dupa stergere, proiectul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminOngoingProjects;
